
define("bundles/catalogsearch-result-index", function(){});
